import { createCrudService } from '@/services/api/createCrudService'

/**
 * Prestadores de serviço (Rede Própria, Medicar, Porto Seguro, MAG, PAP,
 * Auster). Catálogo simples — usado depois pelos serviços e produtos.
 */
export interface ServiceProvider {
  id: string
  name: string
  status: 'ATIVO' | 'INATIVO'
}

export const ServiceProvidersService = createCrudService<ServiceProvider>(
  '/settings/service-providers',
  { searchField: 'name' },
)
